module.exports = __webpack_public_path__ + "static/la-barclays-partnership-b5f0ba0fcdd2be1f7470421ed8ec2327.png";